import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { NutritionActions } from './nutrition.actions';
import { NutritionSelectors } from './nutrition.selectors';
import {AsyncActionQueries, AsyncActionSelectors} from '@emm/core/util/async-action-state';
import {NutritionAssignment, NutritionLocation, NutritionSaveRequest} from '@emm/core/models/nutrition.model';
import {AsyncActionStoreService} from '@emm/core/store/async-action-store.service';
import {State as CoreState} from '@emm/core/store/core.reducer';


export interface NutritionQueries extends AsyncActionQueries {
    assignment$: Observable<NutritionAssignment>;
    assignments$: Observable<NutritionAssignment[]>;
    centerLoading$: Observable<boolean>;
    location$: Observable<NutritionLocation>;
    locationSetType$: Observable<string>;
    profileOptions$: Observable<number[]>;
    rightLoading$: Observable<boolean>;
    selectedDate$: Observable<number>;
}

@Injectable({ providedIn: 'root' })
export class NutritionStoreService extends AsyncActionStoreService<AsyncActionSelectors> {

    constructor(store: Store<CoreState>) {
        super(store, NutritionSelectors);
    }

    dispatch = {
        initNutrition: () => this.store.dispatch(NutritionActions.initNutrition()),
        loadAssignments: () => this.store.dispatch(NutritionActions.loadAssignments()),
        loadProfileOptions: () => this.store.dispatch(NutritionActions.loadProfileOptions()),
        // tslint:disable-next-line:max-line-length
        saveLocationAssignment: (apiData: NutritionSaveRequest) => this.store.dispatch(NutritionActions.saveLocationAssignment({ apiData })),
        selectAssignment: (assignment: NutritionAssignment) => this.store.dispatch(NutritionActions.selectAssignment({ assignment })),
        // tslint:disable-next-line:max-line-length
        selectNutritionLocation: (location: NutritionLocation) => this.store.dispatch(NutritionActions.selectNutritionLocation({ location })),
        // tslint:disable-next-line:max-line-length
        selectNutritionLocationSetType: (locationSetType: string) => this.store.dispatch(NutritionActions.selectNutritionLocationSetType({ locationSetType })),
        selectNutritionLocationSetTypeSuccess: () => this.store.dispatch(NutritionActions.selectNutritionLocationSetTypeSuccess()),
        selectDate: (date: number) => this.store.dispatch(NutritionActions.selectDate({ date })),
        unselectLocation: () => this.store.dispatch(NutritionActions.unselectLocation())
    };

    queries: NutritionQueries = {
        assignment$: this.select(NutritionSelectors.getAssignment),
        assignments$: this.selectNonNil(NutritionSelectors.getAssignments),
        centerLoading$: this.select(NutritionSelectors.getCenterLoading),
        location$: this.select(NutritionSelectors.getLocation),
        locationSetType$: this.select(NutritionSelectors.getLocationSetType),
        profileOptions$: this.selectNonNil(NutritionSelectors.getProfileOptions),
        rightLoading$: this.select(NutritionSelectors.getRightLoading),
        selectedDate$: this.select(NutritionSelectors.getDate),
        ...this.asyncActionQueries
    };

}
